export default __webpack_public_path__ + "c1925cd230da18595b85cf205ecc663c.svg";